<template>
  <div v-if="model">
    <v-dialog scrollable v-model="model" persistent max-width="1000px">
      <employer-wizard :id="id" @close="$emit('close')"/>
    </v-dialog>
  </div>
</template>

<script>
import EmployerWizard from "@/components/Employers/EmployerWizard.vue"

export default {
  components: {
    EmployerWizard
  },
  props: ["model", "id"],
  data() {
    return {
    };
  },
};
</script>
